import { gql } from 'graphql-tag';

const nsNotifications = gql`
  query nsNotifications($after: String, $first: Float!) {
    nsNotifications(after: $after, first: $first) {
      notifications {
        id
        refId
        type
        title
        titleShort
        createdAt
        readAt
        contentType
        content {
          ... on NSNotificationContentHTML {
            html
          }
        }
        contentText
        imageUrl
        metadata
      }
    }
  }
`;

const nsNotificationsCount = gql`
  query nsNotificationsCount($filter: NS_NOTIFICATION_READ_STATUS_FILTER = ALL) {
    nsNotificationsCount(filter: $filter) {
      status
      count
    }
  }
`;

export { nsNotifications, nsNotificationsCount };
